import { render } from "./SearchBarFilters.vue?vue&type=template&id=ca4dcc44&scoped=true"
import script from "./SearchBarFilters.vue?vue&type=script&lang=js"
export * from "./SearchBarFilters.vue?vue&type=script&lang=js"

import "./SearchBarFilters.vue?vue&type=style&index=0&id=ca4dcc44&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ca4dcc44"]])

export default __exports__